<template>
    <label :class="['flex items-center bg-white rounded-md border h-10 p-2 text-sm text-black', error ? 'border-danger' : 'border-gray-400']">
        <font-awesome v-if="icon" :icon="icon" class="h-4 w-8" />
        <input
            :id="id"
            class="placeholder-gray-500 outline-none text-sm flex-1 max-w-full"
            @input="$emit('update:modelValue', $event.target.value)"
            :value="modelValue"
            :placeholder="placeholder"
            v-bind="$props"
        />
    </label>
</template>

<script setup>
    const { modelValue, icon, placeholder, id, error } = defineProps(['modelValue', 'icon', 'placeholder', 'id', 'error']);
</script>
